import { createTheme } from '@mui/material/styles';
import { deepmerge } from '@mui/utils';
import { ThemeConfig, ThemeOptions } from './types';

class Theme {
  public allThemeConfig: ThemeConfig;

  constructor(config: ThemeConfig) {
    this.allThemeConfig = config;
  }

  createTheme(themeType: string, options: ThemeOptions = {}): ThemeOptions {
    if (!this.allThemeConfig[themeType])
      throw new Error(`Can't load theme : ${themeType}, please initialize when create theme instance`);
    return { ...createTheme(deepmerge(this.allThemeConfig[themeType], options)) };
  }
}

export default Theme;
